import {Action} from '@ngrx/store';
import {ArrayResponse} from '../../shared/models/array-response';
import {type} from '../../shared';
import {SelectedItem} from '../../order/models/order';
import {ShippingsFilter, ShippingsList} from '../models/shippings-list';

export const shippingListActionTypes = {
  TOGGLE_SEARCH: type('[shippings] Toggle Search Form'),
  QUICK_SEARCH: type('[shippings] Quick Search'),
  SEARCH: type('[shippings] Search'),
  CHANGE_PAGE_SIZE: type('[shippings] Change Page Size'),
  PAGE_TO: type('[shippings] Page To'),
  ORDER_BY: type('[shippings] Order By'),
  LOAD: type('[shippings] Load'),
  LOAD_SUCCESS: type('[shippings] Load Success'),
  LOAD_FAIL: type('[shippings] Load Fail'),
  SELECT_PAGE: type('[shippings] Select Page'),
  UNSELECT_PAGE: type('[shippings] Unselect Page'),
  TOGGLE_SELECTION: type('[shippings] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[shippings] Toggle Selection Tags'),
  CLEAR: type('[shippings] Clear Data')
};


export class ToggleSearchShippingsAction implements Action {
  readonly type = shippingListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchShippingsAction implements Action {
  readonly type = shippingListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchShippingsAction implements Action {
  readonly type = shippingListActionTypes.SEARCH;
  constructor(public payload?: {data: ShippingsFilter, fragment: string} ) {}
}

export class ChangeShippingsPageSizeAction implements Action {
  readonly type = shippingListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageShippingsToAction implements Action {
  readonly type = shippingListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderShippingsByAction implements Action {
  readonly type = shippingListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadShippingsAction implements Action {
  readonly type = shippingListActionTypes.LOAD;
  constructor() {}
}

export class LoadShippingsSuccessAction implements Action {
  readonly type = shippingListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<ShippingsList>) {
  }
}

export class LoadShippingsFailAction implements Action {
  readonly type = shippingListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectShippingsPageAction implements Action {
  readonly type = shippingListActionTypes.SELECT_PAGE;
  constructor() {}
}

export class UnselectShippingsPageAction implements Action {
  readonly type = shippingListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ToggleShippingsSitesSelectionAction implements Action {
  readonly type = shippingListActionTypes.TOGGLE_SELECTION;
  constructor(public payload?: SelectedItem) {}
}
export class ClearShippingsAction implements Action {
  readonly type = shippingListActionTypes.CLEAR;
  constructor() {}
}
